import axios from '@/axiosInterceptor';

const state = () => ({
  informationPanels: [
    {
      icon: 'icon-lock',
      title: 'Your identity will remain confidential',
      content:
        'Your own identity and the identity of your company will be protected to the extent permitted by law.',
    },
    // {
    //     icon: 'icon-not-allowed',
    //     title: 'The carrier will not be contacted',
    //     content: 'Your identity will beSubmissions are anonymous unless required by law.'
    //     // content: 'If the carrier is made aware of the alert through some other means and contests it, we may ask you for hard evidence of the incident.'
    // },
    {
      icon: 'icon-page',
      title: 'Your alert may or may not be published',
      content:
        'Highway may accept or reject submissions based on our sole discretion.  We do not endorse any submissions and the opinions of the alerts represent your own.',
    },
    {
      icon: 'icon-email',
      title: 'Users can send you inquiries',
      content:
        'If published, other users will be able to message you about your alert without knowing your identity and you will have the option to respond.',
    },
    // ,
    // {
    //     icon: 'icon-calendar',
    //     title: 'It will take time',
    //     content: 'Alerts of this nature are taken seriously.'
    // }
  ],
  alertCategories: [
    {
      label: 'Double Brokering',
      parragraph:
        "The carrier booked a load and then brokered it again to a different carrier without the shipper or broker's knowledge",
      id: 'double_brokering',
    },
    {
      label: 'Identity Theft',
      parragraph:
        "The carrier's identity was used by another person or another company without the carrier's permission",
      id: 'identity_theft',
    },
    {
      label: 'Hostage Load',
      parragraph:
        'The carrier refused to release freight upon demand or otherwise exerted unauthorized control over freight',
      id: 'hostage_load',
    },
    {
      label: 'Stolen Assets',
      parragraph:
        'The carrier stole equipment, such as a power unit or trailer, or cargo from a broker or shipper',
      id: 'stolen_assets',
    },
    {
      label: 'Trailer Misuse',
      parragraph:
        'The carrier misused a trailer by overloading it, damaging it, or using it for purposes other than what it was intended for',
      id: 'trailer_misuse',
    },
    {
      label: 'Back Solicitation',
      parragraph:
        "The carrier used information obtained from a broker to solicit the business of the broker's customer directly",
      id: 'back_soliciting',
    },
    {
      label: 'Unresolved Insurance Claims',
      parragraph:
        'The carrier failed to resolve a legitimate, documented claim filed by a broker or shipper',
      id: 'unresolved_insurance_claims',
    },
    {
      label: 'Change in Ownership',
      parragraph:
        'This carrier recently purchased an MC number and may be misrepresenting their authority and inspection history',
      id: 'change_in_ownership',
    },
    {
      label: 'Bankruptcy Filing',
      parragraph:
        'The carrier has filed for bankruptcy or is undergoing bankruptcy proceedings',
      id: 'bankruptcy_filing',
    },
  ],
  commodities: [],
});

// getters
const getters = {};

// actions
const actions = {
  async createIdentityAlert(_, payload) {
    const body = {
      identity_alert: {
        carrier_id: payload.carrier_id,
        is_type: payload.is_type,
        unsanitized_message: payload.message,
        file_date: payload.file_date,
        // phone: payload.phone,
        phone_e164: payload.phone_e164?.replaceAll('-', ''),
        email: payload.email,
        origin_postal_code: payload.origin_postal_code,
        origin_area_id: payload.origin_area_id,
        site: 'highway.com',
        commodity_type_id: payload.commodity_type_id,
      },
    };
    // if (payload.phone?.length > 0 && payload.phone_e164?.length > 0) {
    //     body.identity_alert.phone = payload.phone;
    //     body.identity_alert.phone_e164 = payload.phone_e164;
    // }
    if (payload.email?.length > 0) {
      body.identity_alert.email = payload.email?.trim();
    }
    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/identity_alerts',
        body
      );
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },

  async createWatchdogAlert(_, payload) {
    const body = {
      identity_alert: {
        carrier_id: payload.carrier_id,
        is_type: payload.report_type,
        file_date: payload.alert_date,
        unsanitized_message: payload.alert_text,
        message_for_display: payload.alert_text,
        site: 'tiawatchdog.com',
        email: null,
        phone: null,
        phone_e164: null,
      },
    };
    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/identity_alerts',
        body
      );
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async sendMessageToPublisher(_, payload) {
    const body = {
      identity_alert_message: {
        identity_alert_id: payload.identity_alert_id,
        message: payload.message,
      },
    };
    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/identity_alert_messages',
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async unPublish(_, identityAlertId) {
    try {
      let res = await axios.patch(
        process.env.API_MONITOR +
          `/api/v1/identity_alerts/${identityAlertId}/unpublish`
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCommodities({ commit }) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR + `/api/v1/commodity_types?q[s]=name+asc`
      );
      commit('setCommodities', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setCommodities(state, commodities) {
    state.commodities = commodities;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
